import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  IconButton,
  Paper,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  Stack,
  Button,
  Tooltip,
} from "@mui/material";
import PersonAddRoundedIcon from "@mui/icons-material/PersonAddRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import VpnKeyRoundedIcon from "@mui/icons-material/VpnKeyRounded";
import HowToRegRoundedIcon from "@mui/icons-material/HowToRegRounded";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";
import { isEmpty } from "lodash";
import SmallModal from "../../../components/modals/SmallModal";

import Swal from "sweetalert2";
import { DataContext } from "../../../context/DataContext";
import { deleteToken, deleteUserData, getToken } from "../../../api/Account";
import { getRuta, isAccess, simpleMessage } from "../../../helpers/Helpers";
import {
  deleteUserAsync,
  getAllUserAsync,
  getInactiveUserListAsync,
  getUserListAsync,
  reactivateUserAsync,
  resetUserPasswordAsync,
} from "../../../api/Users";
import NoData from "../../../components/NoData";
import SearchField from "../../../components/ui/SearchField";
import ListFooter from "../../../components/ui/ListFooter";
import SegmentedTabs from "../../../components/ui/SegmentedTabs";
import StatusChip from "../../../components/ui/StatusChip";
import MigrateWallet from "./MigrateWallet";
import { getTokens } from "../../../theme";

const Userlist = () => {
  const [userList, setUserList] = useState([]);

  const [localReload, setLocalReload] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { setIsLoading, setIsLogged, setIsUnautorized, access, isDarkMode } =
    useContext(DataContext);
  const t = getTokens(isDarkMode);
  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  const [active, setActive] = useState(0);

  const [searchTerm, setSearchTerm] = useState("");

  const withSearch = userList.filter((val) => {
    if (searchTerm === "") {
      return val;
    } else if (
      val.id.toString().includes(searchTerm) ||
      (val.fullName || "").toString().includes(searchTerm) ||
      (val.userName || "").toString().includes(searchTerm.toLocaleLowerCase())
    ) {
      return val;
    }
    return false;
  });

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      let result = [];
      if (active === 0) {
        result = await getUserListAsync(token);
      }

      if (active === 1) {
        result = await getInactiveUserListAsync(token);
      }

      if (active === 2) {
        result = await getAllUserAsync(token);
      }

      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setUserList(result.data.result);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localReload]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsperPage] = useState(10);
  const indexLast = currentPage * itemsperPage;
  const indexFirst = indexLast - itemsperPage;
  const currentItem = withSearch.slice(indexFirst, indexLast);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const deleteUser = async (item) => {
    Swal.fire({
      title: "¿Estas Seguro?",
      text: "No podras revertir esto...!",
      icon: "warning",
      showCancelButton: true,

      confirmButtonColor: "#1d4ed8",
      cancelButtonColor: "#d83a3f",

      confirmButtonText: "Eliminar!",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "border",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        (async () => {
          setIsLoading(true);
          const result = await deleteUserAsync(token, item.id);
          if (!result.statusResponse) {
            setIsLoading(false);
            if (result.error === "Unauthorized") {
              setIsUnautorized(true);
              return;
            }
            simpleMessage(result.error, "error");
            return;
          }
          if (result.error === "eX01") {
            setIsLoading(false);
            deleteUserData();
            deleteToken();
            setIsLogged(false);
            return;
          }
          setIsLoading(false);
          setLocalReload(!localReload);
          Swal.fire("Eliminado!", "Usuario Eliminado.", "success");
        })();
      }
    });
  };

  const reactivateUser = async (item) => {
    Swal.fire({
      title: "¿Estas Seguro?",
      text: "Darás acceso al sistema a este usuario...!",
      icon: "warning",
      showCancelButton: true,

      confirmButtonColor: "#1d4ed8",
      cancelButtonColor: "#d83a3f",

      confirmButtonText: "Proceder!",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "border",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        (async () => {
          setIsLoading(true);
          const result = await reactivateUserAsync(token, item.id);
          if (!result.statusResponse) {
            setIsLoading(false);
            if (result.error === "Unauthorized") {
              setIsUnautorized(true);
              return;
            }
            simpleMessage(result.error, "error");
            return;
          }
          if (result.error === "eX01") {
            setIsLoading(false);
            deleteUserData();
            deleteToken();
            setIsLogged(false);
            return;
          }
          setIsLoading(false);
          setLocalReload(!localReload);
          Swal.fire("Reactivado!", "Usuario activado.", "success");
        })();
      }
    });
  };

  const onChangeSearch = (val) => {
    setCurrentPage(1);
    setSearchTerm(val.toUpperCase());
    paginate(1);
  };

  const onSelectChange = async (value) => {
    setActive(value);
    setCurrentPage(1);
    setIsLoading(true);
    let result = [];
    if (value === 0) {
      result = await getUserListAsync(token);
    }

    if (value === 1) {
      result = await getInactiveUserListAsync(token);
    }

    if (value === 2) {
      result = await getAllUserAsync(token);
    }

    if (!result.statusResponse) {
      if (result.error === "eX01") {
        setIsLoading(false);
        deleteUserData();
        deleteToken();
        setIsLogged(false);
        return;
      }
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      simpleMessage(result.error, "error");
      return;
    }

    setIsLoading(false);
    setUserList(result.data.result);
  };

  const resetPassword = async (item) => {
    Swal.fire({
      title: "¿Estas Seguro?",
      text: "Se estableceras la contraseña por defecto...!",
      icon: "warning",
      showCancelButton: true,

      confirmButtonColor: "#1d4ed8",
      cancelButtonColor: "#d83a3f",

      confirmButtonText: "Proceder!",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "border",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        (async () => {
          setIsLoading(true);
          const result = await resetUserPasswordAsync(token, item.id);
          if (!result.statusResponse) {
            setIsLoading(false);
            if (result.error === "Unauthorized") {
              setIsUnautorized(true);
              return;
            }
            simpleMessage(result.error, "error");
            return;
          }
          if (result.error === "eX01") {
            setIsLoading(false);
            deleteUserData();
            deleteToken();
            setIsLogged(false);
            return;
          }
          setIsLoading(false);
          setLocalReload(!localReload);
          Swal.fire(
            "Contrseña Reseteada!",
            "Nueva Contraseña es 123456.",
            "success"
          );
        })();
      }
    });
  };

  const actionButtonSx = {
    width: 32,
    height: 32,
    borderRadius: "9px",
    border: `1px solid ${t.fieldLine}`,
    backgroundColor: t.field,
  };

  const puedeAccionar =
    isAccess(access, "SECURITY UPDATE") || isAccess(access, "SECURITY DELETE");

  return (
    <div>
      <Paper sx={{ overflow: "hidden" }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "stretch", sm: "center" }}
          spacing={2}
          flexWrap="wrap"
          sx={{ padding: "18px 22px", borderBottom: "1px solid", borderColor: "divider" }}
        >
          <SearchField
            value={searchTerm}
            onChange={onChangeSearch}
            placeholder="Buscar por usuario o nombre…"
          />

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            alignItems={{ xs: "stretch", sm: "center" }}
            flexWrap="wrap"
          >
            <SegmentedTabs
              tabs={[{ label: "Activos" }, { label: "Inactivos" }, { label: "Todos" }]}
              value={active}
              onChange={onSelectChange}
            />

            {isAccess(access, "MIGRAR CARTERA") ? (
              <Button
                onClick={() => setShowModal(true)}
                startIcon={<SwapHorizRoundedIcon />}
                variant="outlined"
                sx={{ whiteSpace: "nowrap", height: "44px" }}
              >
                Migrar cartera
              </Button>
            ) : null}

            {isAccess(access, "SECURITY CREATE") ? (
              <Button
                onClick={() => navigate(`${ruta}/adduser`)}
                startIcon={<PersonAddRoundedIcon />}
                variant="contained"
                color="primary"
                sx={{ whiteSpace: "nowrap", height: "44px" }}
              >
                Agregar usuario
              </Button>
            ) : null}
          </Stack>
        </Stack>

        {isEmpty(currentItem) ? (
          <NoData />
        ) : (
          <>
            <TableContainer sx={{ overflowX: "auto" }}>
              <Table sx={{ minWidth: 720 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Usuario</TableCell>
                    <TableCell>Nombre completo</TableCell>
                    <TableCell align="center">Teléfono</TableCell>
                    <TableCell align="center">Rol</TableCell>
                    {puedeAccionar ? <TableCell align="center">Acciones</TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentItem.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell sx={{ fontWeight: 700, color: "text.primary" }}>{row.userName}</TableCell>
                      <TableCell sx={{ color: "text.secondary" }}>{row.fullName}</TableCell>
                      <TableCell align="center" sx={{ color: "text.secondary" }}>
                        {row.phone}
                      </TableCell>
                      <TableCell align="center">
                        <StatusChip
                          label={row.userRol.rolName}
                          tone={row.isActive ? "success" : "neutral"}
                        />
                      </TableCell>
                      {puedeAccionar ? (
                        <TableCell align="center">
                          <Stack direction="row" spacing={1} justifyContent="center">
                            {isAccess(access, "SECURITY UPDATE") ? (
                              <Tooltip title="Ver detalle">
                                <IconButton
                                  size="small"
                                  sx={{ ...actionButtonSx, color: "primary.main" }}
                                  onClick={() => navigate(`${ruta}/user/${row.id}`)}
                                >
                                  <VisibilityRoundedIcon sx={{ fontSize: 15 }} />
                                </IconButton>
                              </Tooltip>
                            ) : null}

                            {isAccess(access, "SECURITY UPDATE") && row.isActive ? (
                              <Tooltip title="Restablecer contraseña">
                                <IconButton
                                  size="small"
                                  sx={{ ...actionButtonSx, color: "warning.main" }}
                                  onClick={() => resetPassword(row)}
                                >
                                  <VpnKeyRoundedIcon sx={{ fontSize: 15 }} />
                                </IconButton>
                              </Tooltip>
                            ) : null}

                            {isAccess(access, "SECURITY DELETE") ? (
                              <Tooltip title={row.isActive ? "Eliminar" : "Reactivar"}>
                                <IconButton
                                  size="small"
                                  sx={{
                                    ...actionButtonSx,
                                    color: row.isActive ? "error.main" : "success.main",
                                  }}
                                  onClick={() =>
                                    row.isActive ? deleteUser(row) : reactivateUser(row)
                                  }
                                >
                                  {row.isActive ? (
                                    <DeleteRoundedIcon sx={{ fontSize: 15 }} />
                                  ) : (
                                    <HowToRegRoundedIcon sx={{ fontSize: 15 }} />
                                  )}
                                </IconButton>
                              </Tooltip>
                            ) : null}
                          </Stack>
                        </TableCell>
                      ) : null}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <ListFooter
              data={withSearch}
              currentCount={currentItem.length}
              indexFirst={indexFirst}
              paginate={paginate}
              itemsperPage={itemsperPage}
              noun="usuarios"
            />
          </>
        )}
      </Paper>

      <SmallModal
        titulo={"Migrar Cartera"}
        isVisible={showModal}
        setVisible={setShowModal}
      >
        <MigrateWallet
          setShowModal={setShowModal}
          localReload={localReload}
          setLocalReload={setLocalReload}
        />
      </SmallModal>
    </div>
  );
};

export default Userlist;
